// src/components/Content.tsx
import { Badge, Box, Flex, Section, Separator } from '@radix-ui/themes';
import React, { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import styles from '../styles/Content.module.scss';
import { routes } from '../routes';
interface ContentProps {
  children: ReactNode;
}

const pageTitles = {
  [routes.dashboard]: "Painel",
  [routes.users]: "Listagem de utilizadores",
  [routes.createUser]: "Criar utilizador",
  [routes.updateUser]: "Editar utilizador",
  [routes.roles]: "Listagem de perfis",
  [routes.createRole]: "Criar perfil",
  [routes.addClaimsToRole]: "Adicionar permissões ao perfil",
  [routes.faculties]: "Listagem de unidades orgânica",
  [routes.createFaculty]: "Criar unidade orgânica",
  [routes.updateFaculty]: "Editar unidade orgânica",
  [routes.departaments]: "Listagem de departamentos",
  [routes.createDepartament]: "Criar departamento",
  [routes.updateDepartament]: "Editar departamento",
  [routes.courses]: "Listagem de cursos",
  [routes.createCourse]: "Criar (curso / programa)",
  [routes.updateCourse]: "Editar curso",
  [routes.scientificAreas]: "Listagem de áreas científicas",
  [routes.createScientificAreas]: "Criar área científica",
  [routes.updateScientificAreas]: "Editar área científica",
  [routes.academicPeriods]: "Listagem de períodos acadêmicos",
  [routes.createAcademicPeriod]: "Criar período acadêmico",
  [routes.updateAcademicPeriod]: "Editar período acadêmico",
  [routes.subjects]: "Listagem de disciplinas",
  [routes.createSubject]: "Criar disciplina",
  [routes.updateSubject]: "Editar disciplina",
  [routes.academicYears]: "Anos acadêmicos",
  [routes.enrollmentrequireddocuments]: "Documentos necessários para matrícula",
  [routes.createEnrollmentRequiredDocument]: "Criar documento de matrícula",
  [routes.updateEnrollmentRequiredDocument]: "Editar documento de matrícula",
  [routes.createEnrollment]: "Criar matrícula",
  [routes.enrollments]: "Listagem de matrículas",
  [routes.updateEnrollment]: "Editar matrícula",
  [routes.teacherRequiredDocuments]: "Documentos exigidos para docentes",
  [routes.createTeacherRequiredDocument]: "Criar documento para docente",
  [routes.updateTeacherRequiredDocument]: "Editar documento para docente",
  [routes.teachers]: "Listagem de docentes",
  [routes.createTeacher]: "Criar docente",
  [routes.updateTeacher]: "Editar docente",
  [routes.classes]: "Listagem de turmas",
  [routes.createClass]: "Criar turma",
  [routes.updateClass]: "Editar turma",
  [routes.assessments]: "Avaliações",
  [routes.createAssessments]: "Criar avaliação",
  [routes.updateAssessments]: "Editar avaliação",
  // [routes.coursesSubjects]: "Disciplinas do curso",
  [routes.createCourseSubject]: "Criar disciplina para curso",
  [routes.updateCourseSubject]: "Editar disciplina do curso",
  [routes.createSubscription]: "Criar inscrição",
  [routes.updateSubscription]: "Editar inscrição",
  [routes.subscriptions]: "Listagem de inscrições",
  [routes.createMySubscription]: "Criar Pre-inscrição",
  [routes.userRoleAndCLaims]: "Permissões de utilizadores",
  [routes.addStudentGradesV2]: "Adicionar notas de estudante",
  [routes.addStudentGrades]: "Notas de estudante - (Pauta de frequência)",
  [routes.addStudentExamGrades]: "Notas de estudante - (Pauta de exames)",
  [routes.createClassroom]: "Criar sala de aula",
  [routes.updateClassroom]: "Editar sala de aula",
  [routes.classrooms]: "Listagem de salas de aula",
  [routes.classroomTypes]: "Tipos de salas de aula",
  [routes.createClassroomType]: "Criar tipo de sala",
  [routes.updateClassroomType]: "Editar tipo de sala",
  [routes.vacancies]: "Vagas",
  [routes.createVacancy]: "Criar vaga",
  [routes.updateVacancy]: "Editar vaga",
  [routes.manageSchedule]: "Gerenciar horário de turmas",
  [routes.studentSchedule]: "Horário do estudante",
  [routes.studentGrades]: "Notas do estudante",
  [routes.myAssessments]: "Minhas avaliações",
  [routes.createTeacherEvaluationCriteria]: "Criar critério de avaliação para docentes",
  [routes.updateTeacherEvaluationCriteria]: "Editar critério de avaliação",
  [routes.teacherEvaluationCriterias]: "Critérios de avaliação para docentes",
  [routes.studentTeacherEvaluation]: "Avaliação de docentes por estudantes",
  [routes.teacherEvaluations]: "Avaliações de docentes",
  [routes.studentDocuments]: "Documentos de estudantes",
  [routes.requestStudentDocument]: "Solicitar documento de estudante",
  [routes.findStudentGrades]: "Ver notas do estudante",
  [routes.addSubjectPlan]: "Adicionar plano da disciplina",
  [routes.getSubjectPlans]: "Listar planos da disciplina",
  [routes.getManagers]: "Listar responsáveis",
  [routes.createManager]: "Criar responsável",
  [routes.updateManager]: "Actualizar responsável",
  [routes.lateFeeConfigs]: "Listagem de regras de multas",
  [routes.createlateFeeConfig]: "Criar regra de multas",
  [routes.updatelateFeeConfig]: "Actualizar regra de multas",
  [routes.studentDebts]: "Cobranças",
  [routes.irregularStudentDebts]: "Cobranças - (Irregulares)",
  [routes.createStudent]: "Criar Cobrança",
  [routes.getStudentFinanceState]: "Situação financeira",
  [routes.getStudentFinanceNotifications]: "Notificações",
  [routes.getFinanceReports]: "Relatórios",
  [routes.updateStudentDebt]: "Actualizar Cobrança",
  [routes.curriculumGrid]: "Grelha curricular",
  // [routes.courseSubjectV2]: "Criar Grelha curricular",
  [routes.renewEnrollment]: "Renovar matricula",
  [routes.createCoursePayment]: "Criar taxa do curso",
  [routes.updateCoursePayment]: "Actualizar taxa do curso",
  [routes.coursePayments]: "Taxas por curso",
  [routes.subscriptionsStatistics]: "Inscrições por disciplina",
  [routes.subscriptionsStatisticsCourse]: "Inscrições por curso",
  [routes.universities]: "Listagem de instituiçöes de ensino superior",
  [routes.assignManager]: 'Vicular responsável',
  [routes.createUniversity]: "Criar instituição de ensino superior",
  [routes.updateUniversity]: "Actualizar instituição de ensino superior",
  [routes.studentStatistics]: "Estatísticas",
  [routes.coursePlans]: 'Listagem de plano de curso',
  [routes.createCoursePlan]: 'Criar plano de curso',
  [routes.updateCoursePlan]: 'Atualizar plano de curso',
  [routes.createScholarshipType]: 'Criar o tipo de bolsa',
  [routes.updateScholarshipType]: 'Actualizar o tipo de bolsa',
  [routes.scholarshipTypes]: 'Listagem de tipo de bolsa',
  [routes.scholarshipProviders]: 'Listagem de provedores de bolsa',
  [routes.createScholarshipProvider]: 'Criar provedores de bolsa',
  [routes.updateScholarshipProvider]: 'Actualizar provedores de bolsa',
  [routes.scholarships]: 'Listagem de bolsas',
  [routes.createScholarship]: 'Atribuir bolsa',
  [routes.updateScholarship]: 'Actualizar bolsa',
  [routes.teacherClasses]: 'Minhas Turmas',
  [routes.changePasswordPolicy]: 'Actualizar políticas da senha',
  [routes.getPaymentReport]: 'Relatório de pagamentos',
  [routes.getPaymentReferenceStatus]: 'Relatório de referências',
  [routes.duplicatedSchoolCodes]: 'Códigos duplicados',
  [routes.bulkEnrollmentByExcelFile]: 'Carregamento em massa de estudantes',
  [routes.blockOrUnblockStudentGradePosting]: 'Bloquear ou desbloquear o lançamento de notas dos estudantes',
  [routes.processModels]: 'Listagem de modelos de processos',
  [routes.createProcessModel]: 'Criar modelo de processo',
  [routes.updateProcessModel]: 'Actualizar modelo de processo',
  [routes.generalStudentGrades]: 'Pauta geral',
  [routes.viewStudentGrades]: 'Pauta de frequência geral',
  [routes.viewStudentExamGrades]: 'Pauta de exames geral',
  [routes.studentGeneralGrades]: 'Notas gerais do estudente',
  [routes.certificates]: 'Listagem de certificados',
  [routes.uploadStudentCertificate]: 'Carregar certificado',
};

const Content: React.FC<ContentProps> = ({ children }) => {

  const location = useLocation();

  const getCurrentPage = () => {
    return pageTitles[location.pathname]??"Painel";
  };

  return (
    <Box className={styles.content}>
      <Section size="1">
        <Flex align="center" gap="2">
          <Badge variant="surface" >e-Sura</Badge>
          <Separator orientation="vertical" />
          <Badge variant="solid" >{getCurrentPage()}</Badge>
        </Flex>
      </Section>

      {children}
    </Box>
  );
};

export default Content;